<medrecord-auth-twofa-action-buttons
  [primaryButtonLabel]="primaryButtonLabel"
  [primaryButtonType]="primaryButtonType"
  [showPrimaryButton]="showPrimaryButton"
  [showCancelButton]="showCancelButton"
  [customerName]="clientName$ | async"                                     
  (primaryButton)="primaryButtonClick()"
  (cancelButton)="cancelButtonClick()"
>
</medrecord-auth-twofa-action-buttons>